import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';

import { ConceptGroupDetailView } from '@verantos-dev/feature-concept-group-detail';
import { Dialog } from '@verantos-dev/shared-components';

export interface ConceptGroupDetailModalProps {
  conceptGroupId: string;
  onClose: () => void;
}

/**
 * Modal presentation of the shared Ready-view concept-group detail
 * ({@link ConceptGroupDetailView}) for the standalone concept-groups list.
 *
 * Replaces the legacy full-screen datagrid dialog: clicking a row now opens the
 * SAME read-only surface the agent-first project page shows (asset header +
 * ``Ready`` status chip + source-file bar + concepts grid), framed in a large
 * modal instead of a full page. The view renders its own header/title, so the
 * modal chrome is just a sized frame + a close button. The view's TanStack reads
 * run against the app-level QueryClient.
 */
export const ConceptGroupDetailModal = ({
  conceptGroupId,
  onClose,
}: ConceptGroupDetailModalProps) => (
  <Dialog
    id="concept-group-detail-modal"
    data-testid="concept-group-detail-modal"
    open
    onClose={onClose}
    fullWidth
    maxWidth="lg"
    // A definite height lets the view's flex-column layout distribute space so the
    // concepts grid paginates/scrolls inside the modal rather than growing it.
    PaperProps={{ sx: { height: '85vh' } }}
  >
    <IconButton
      aria-label="close"
      data-testid="concept-group-detail-modal-close"
      onClick={onClose}
      sx={{
        position: 'absolute',
        right: 12,
        top: 12,
        zIndex: 1,
        color: (theme) => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
    <Box sx={{ height: '100%', minHeight: 0, overflow: 'hidden' }}>
      <ConceptGroupDetailView conceptGroupId={conceptGroupId} />
    </Box>
  </Dialog>
);
